<template>
    <section class="hot-panel-img">
        <section-title :title="title" />
        <div v-show="list.length > 1" :id="swiperId" class="swiper-container">
            <div class="swiper-wrapper">
                <img v-for="(item, idx) in list" :key="idx" :src="item.imgUrl" class="swiper-slide" alt="" />
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
        </div>
        <div v-show="list.length === 1" class="swiper-container">
            <div class="swiper-wrapper">
                <img v-for="(item, idx) in list" :key="idx" :src="item.imgUrl" class="swiper-slide" alt="" />
            </div>
        </div>
    </section>
</template>

<script>
import Swiper from 'swiper';
import SectionTitle from './sectionTitle';

export default {
    name: 'HotPanelImg',
    components: {
        SectionTitle
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiperId: Math.floor(Math.random() * 100000000),
            mySwiper: null
        };
    },
    watch: {
        list() {
            this.destroySwiper();
            this.createSwiper();
        }
    },
    mounted() {
        this.createSwiper();
    },
    methods: {
        createSwiper() {
            this.$nextTick(() => {
                this.mySwiper = new Swiper(`#${this.swiperId}`, {
                    autoplay: 2000,
                    loop: true,
                    autoplayDisableOnInteraction: false,
                    pagination: '.swiper-pagination',
                    paginationClickable: true
                });
            });
        },
        destroySwiper() {
            if (this.mySwiper) {
                this.mySwiper.destroy(false);
                this.mySwiper = null;
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '~swiper/dist/css/swiper.min.css';

.swiper-container {
    height: 126px;
    border-radius: 4px;

    .swiper-slide {
        object-fit: cover;
    }
}
</style>

<style lang="less">
.swiper-pagination.swiper-pagination-bullets {
    bottom: 6px;
    padding: 0 9px;
    height: 14px;
    background: #000000;
    opacity: 0.5;
    border-radius: 26px;
    left: 50%;
    transform: translate(-50%);
    width: auto;
    .swiper-pagination-bullet {
        background: #c4c4c4;
        opacity: 0.5;
        width: 6px;
        height: 6px;
        margin: 4px 3px;
    }
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
        background: #ffffff;
        opacity: 1;
        border-radius: 26px;
        width: 16px;
    }
}
</style>
